module.exports = __webpack_public_path__ + "img/adobe.52a3c51c.png";